import { t } from '../../../../common/components/T';
import { rankColors } from '../../../../project/uikit/data-variables/rank-colors';

export const skeleton = () => {
    return [
        {
            row: [30, 50, 20],
            vertical: 'unset',
            items: [
                {
                    content: [
                        {
                            type: 'title'
                        },
                        {
                            type: 'text',
                            width: 80
                        }
                    ]
                },
                'empty',
                {
                    row: [90, 10],
                    align: 'right',
                    gap: 1,
                    items: [
                        {
                            type: 'circle',
                            align: 'right',
                            diameter: 3
                        },
                        {
                            type: 'circle',
                            align: 'right',
                            diameter: 3
                        }
                    ]
                }
            ]
        },
        'empty',
        {
            row: [30, 70],
            gap: 3,
            items: [
                {
                    type: 'blockXL'
                },
                {
                    content: [
                        {
                            row: [25, 25, 25, 25],
                            items: ['blockSM'],
                            gap: 2
                        },
                        {
                            row: [25, 25, 25, 25],
                            items: ['blockSM'],
                            gap: 2
                        },
                        {
                            row: [25, 25, 25, 25],
                            items: ['blockSM', 'blockSM', 'blockSM', 'empty'],
                            gap: 2
                        }
                    ]
                }
            ]
        },
        'empty',
        'chart'
    ];
};

export const colors = rankColors?.map((color) => color?.color);

export function createWidgetData(data, translation, periodsFromBack) {
    if (!data?.data || !data?.meta) return;
    const period = {
        marketing_period_id_from: +data?.meta?.filter?.marketing_period_from?.id,
        marketing_period_id_to: +data?.meta?.filter?.marketing_period_to?.id,
        from_formatted: data?.meta?.filter?.marketing_period_from?.id_formatted,
        to_formatted: data?.meta?.filter?.marketing_period_to?.id_formatted
    };
    // id останнього періоду
    const lastPeriodId = period?.to_formatted;
    let ranks = [];
    const series = [];
    // сума всіх кваліфікацій (якщо id періода останній то сумуємо, інакше 0)
    const sumOfRanks = data.data.reduce((acc, item) => (acc += item?.marketing_period_id === lastPeriodId ? +item?.count : 0), 0);

    const periodsFiltered = periodsFromBack.slice(
        periodsFromBack.findIndex((per) => +per.id === period.marketing_period_id_from),
        periodsFromBack.findIndex((per) => +per.id === period.marketing_period_id_to) + 1
    );
    const periods = periodsFiltered.map((per) => per?.id_formatted);

    const sortedRanks = [5, 6, 7, 8, 9, 10, 11];
    const ranksFromBack = data.meta?.ranks;

    sortedRanks?.forEach((id) => {
        ranks.push({ id: +id, name: ranksFromBack[id], value: 0 });
    });

    data?.data?.forEach((item) => {
        if (+item?.count) {
            ranks = ranks?.map((rank) => {
                if (rank.id === +item?.marketing_rank_id) {
                    const periodId = item?.marketing_period_id;
                    return {
                        ...rank,
                        value: periodId === lastPeriodId ? rank?.value + +item?.count : rank?.value
                    };
                }
                return rank;
            });
        } else {
        }
    });

    ranks?.map((rank) => {
        const newData = periods.map((period_id) => {
            return data?.data?.reduce((accum, element) => {
                if (element?.marketing_period_id === period_id && rank?.id === +element?.marketing_rank_id) {
                    accum += +element?.count;
                }
                return accum;
            }, 0);
        });
        series.push({
            name: rank.name,
            data: newData,
            color: colors[rank.id]
        });
    });

    const chartConfig = {
        allowChartUpdate: true,
        options: {
            title: false,
            chart: {
                type: 'area',
                className: 'structure-dynamic',
                reflow: true,
                height: 400
            },
            legend: {
                enabled: false
            },
            title: false,
            xAxis: {
                categories: periods
            },
            yAxis: {
                min: 0,
                title: { text: null },
                gridLineColor: '#CCC',
                gridLineDashStyle: 'Dash'
            },
            colors,
            plotOptions: {
                series: {
                    marker: {
                        enabled: periods?.length === 1,
                        symbol: 'circle',
                        radius: 4,
                        states: {
                            hover: {
                                enabled: true
                            }
                        }
                    },
                    lineWidth: 2,
                    fillOpacity: 0.1
                }
            },
            series,
            tooltip: {
                style: {
                    fontFamily: 'inherit'
                },
                crosshairs: true,
                shared: true,
                borderRadius: 0,
                borderWidth: 0,
                shadow: false,
                enabled: true,
                backgroundColor: 'none',
                useHTML: true,
                headerFormat: `<div class="dynamic-rewards-header"><span class="dynamic-rewards-header-label">${t(
                    'calculation_week',
                    'Расчетная неделя',
                    '/office',
                    translation
                )}: <span class="dynamic-rewards-header-value">{point.key}</span></span></div><div class='dynamic-rewards-grid'>`,
                pointFormat: `<div class="dynamic-rewards-item">
                                <div class="dynamic-rewards-item-circle" style="background-color: {series.color}"></div>
                                <div class="dynamic-rewards-info">
                                    <p class='dynamic-rewards-name'>{series.name}</p>
                                    <p class="dynamic-rewards-value">{point.y}</p>
                                </div>
                            </div>`,
                footerFormat: '</div>'
            }
        }
    };

    return {
        sumOfRanks,
        period,
        ranks,
        chartConfig
    };
}
